import { Button, Input, Modal } from '../../../../../common/_custom';
import { EMAIL, NAME, PHONE, TRIGGER_NOTIFICATION, JOB_ROLE } from '../../../../../utils/constants/companyLogin';
import styles from './EditUserModal.module.scss';
import CountryCodesDropdown, { CountryCodeData } from '../../../../Company/CompanyLogin/CountryCodesDropdown/CountryCodesDropdown';
import Dropdown from '../../../../../common/_custom/Dropdown';
import { DEFAULT_JOB_ROLES } from './AddUserModal';
import CheckBox from '../../../../../common/CheckBox/CheckBox';
import { useEditUserModal } from './useEditUserModal';

interface EditUserModalProps {
    isOpen: boolean;
    onClose: () => void;
    userData: any;
    allRowsData?: any;
    onUsersUpdate?: (updatedUsers: any[]) => void;
    countryCodes: CountryCodeData[];
}

const EditUserModal = ({ isOpen, onClose, userData, allRowsData, onUsersUpdate, countryCodes }: EditUserModalProps) => {
    const { loading, formData, formErrors, handleFormChange, handleSave, onClosedModal, isSaveDisabled } = useEditUserModal({
        isOpen,
        userData,
        allRowsData,
        onUsersUpdate,
        countryCodes,
        onClose,
    });

    return (
        <Modal open={isOpen} onClose={onClosedModal} size="flexible" persistent style={{ padding: 0 }}>
            <div className={styles.ModalBody}>
                <h2>Edit User</h2>
                <Input
                    value={formData[NAME]}
                    onChange={(val) => handleFormChange(val, NAME)}
                    placeholder="Full Name"
                    style={{ marginTop: '30px' }}
                    isValid={!formErrors[NAME]}
                    errorMessage={formErrors[NAME]}
                    allowAllCharacters={true}
                />
                <Input
                    value={formData[EMAIL]}
                    onChange={(val) => handleFormChange(val, EMAIL)}
                    placeholder="Email ID"
                    style={{ marginTop: '30px' }}
                    isValid={!formErrors[EMAIL]}
                    errorMessage={formErrors[EMAIL]}
                    allowAllCharacters={true}
                />
                <Dropdown
                    optionsList={DEFAULT_JOB_ROLES}
                    selectedOption={formData[JOB_ROLE] || null}
                    itemClickHandler={(option) => {
                        handleFormChange(option, JOB_ROLE);
                    }}
                    label="Job Role"
                    placeholder="Job Role"
                    enableSearch={true}
                    hideOtherOptionWhenNoMatch={true}
                    customOption={{
                        enabled: true,
                        text: 'Add Other Job Role',
                        placeholder: 'Enter job role...',
                        maxLength: 50,
                    }}
                    style={{ marginTop: '30px' }}
                />
                <div className={styles.Row}>
                    <Input
                        placeholder="Phone Number"
                        value={formData[PHONE]}
                        onChange={(value) => {
                            if (/^\d*$/.test(value) && value.length <= 10) {
                                handleFormChange(value, PHONE);
                            }
                        }}
                        style={{ marginTop: '0', width: '100%' }}
                        type="number"
                        isValid={!formErrors[PHONE]}
                        errorMessage={formErrors[PHONE]}
                    />
                </div>
                <CheckBox
                    label={'Send invite on email'}
                    checked={formData[TRIGGER_NOTIFICATION]}
                    onCheck={(val) => handleFormChange(val, TRIGGER_NOTIFICATION)}
                    variant={'tertiary'}
                    style={{ padding: '1.5rem 0 0rem 0.25rem' }}
                />
            </div>
            <div className={styles.Bottom}>
                <Button
                    onClick={handleSave}
                    text={'Save'}
                    variant="purple"
                    loading={loading}
                    style={{ width: '100%' }}
                    disabled={isSaveDisabled}
                />
            </div>
        </Modal>
    );
};

export default EditUserModal;
